// #region Sync
export const void0 = () => void 0;
export const returnTrue = () => true;
export const returnFalse = () => false;
export const returnO = () => 0;
export const identity = <T>(value: T) => value;
// #endregion

// #region Async
export const emptyAsyncResolve = () => {
  return Promise.resolve() as Promise<any>;
};
export const emptyAsyncReject = () => Promise.reject();
// #endregion
